import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
  Paper,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import { handleAxiosError } from "../../config/action-config";
import { updateProfile } from "../../api/user";
import { showAlert } from "../../actions/alert";
import { useNavigate } from "react-router-dom";
import { Edit, Person } from "@mui/icons-material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getEmployeePersonalDetailById } from "../../api/employee";
import { getUser } from "../../actions/auth";
import TabPanel from "../../component/TabPanel";
import FileUploadComponent from "./uplaodDocuments";
import ResignationDialog from "../resignation/resign.dialog";
import EmployeeResignationDetails from "./resignation.detail.tab";

const useStyles = makeStyles((theme) => ({
  label: {
    color: "grey",
    fontWeight: "bold",
    textAlign: "right",
  },
  text: {
    color: "black",
    textAlign: "left",
  },
  textcapitalize: {
    color: "black",
    textAlign: "left",
    textTransform: "capitalize",
  },
  textcapitalizeNone: {
    color: "black",
    textAlign: "left",
  },
}));

export default function Profile() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const [subTabIndex, setSubTabIndex] = useState(0);
  const [resignationDialogOpen, setResignationDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [rolechange, setRole] = useState([]);
  const wordRegex = /[A-Z]?[a-z]+|[0-9]+|[A-Z]+(?![a-z])/g;
  const [employeePersonalDetail, setEmployeePersonalDetail] = useState({});
  const [showConfidentialInfo, setShowConfidentialInfo] = useState(false);
  const [documentTypeData, setDocumentTypeData] = useState("");
  const toggleConfidentialInfo = () => {
    setShowConfidentialInfo(!showConfidentialInfo);
  };
  useEffect(() => {
    const result = user.role.match(wordRegex);
    setRole(result);
    loadEmployeePersonalDetails();
  }, []);
  const loadEmployeePersonalDetails = async () => {
    try {
      const { data } = await getEmployeePersonalDetailById("me", user.token);
      setEmployeePersonalDetail(data.data.employee);
    } catch (error) {
      alert("Error while loading details.");
    }
  };
  return (
    <>
      <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            if (nv === 1) {
              setDocumentTypeData("Joining_Document");
            } else {
              setDocumentTypeData("Others_Document");
            }
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="My Details"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Joining Documents"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Other Documents"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>

        <TabPanel value={tabIndex} index={0}>
          <Paper>
            <Box sx={{ flexGrow: 1 }}>
              <Paper>
                <Box sx={{ flexGrow: 1, px: { md: 5, sm: 2 }, mx: "auto" }}>
                  <Box
                    sx={{
                      overflow: "hidden",
                      justifyContent: "center",
                      flexDirection: "column",
                      minHeight: showConfidentialInfo ? "66vh" : "45vh",
                      display: "flex",
                    }}
                    // className="profile-box-container-myinfo"
                  >
                    <Box className="profile-box-bg">
                      <Box className="profile-user-icon">
                        <Person />
                      </Box>
                      <Box className="profile-edit-icon">
                        {/*Edit*/}
                        <Edit
                          onClick={() => {
                            setUpdateDialogOpen(true);
                          }}
                          className="blue-button"
                        />
                        {/*End Edit*/}
                      </Box>
                      <Typography className="profile-heading">
                        Your Profile
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4} lg={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.label}>
                                Name
                              </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.textcapitalize}>
                                {user.firstname} {user.lastname}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.label}>
                                Email
                              </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography
                                className={classes.textcapitalizeNone}
                              >
                                {user.email}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.label}>
                                Phone
                              </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.text}>
                                {user.contact}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={4} lg={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.label}>
                                Role
                              </Typography>
                            </Grid>
                            <Grid item xs={6} md={6} lg={6}>
                              {user.role === "ReportingManager" ? (
                                <Typography className={classes.textcapitalize}>
                                  {rolechange[0]} {`${rolechange[1]}`}
                                </Typography>
                              ) : (
                                <Typography className={classes.text}>
                                  {user.role}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.label}>
                                Department
                              </Typography>
                            </Grid>

                            <Grid sx={{ ml: 1 }} item xs={6} md={6} lg={6}>
                              <Typography className={classes.textcapitalize}>
                                {user.department}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Gender
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.text}>
                                    {employeePersonalDetail.gender}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                        {showConfidentialInfo && (
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Date Of Birth
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {formatDate(employeePersonalDetail.dob)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Nationality
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalizeNone}
                                  >
                                    {employeePersonalDetail.nationality}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Marital Status
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.marital_status}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Other Contact
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.other_contact}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Previous Company
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.previous_company}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Previous Job Title
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.previous_job_title}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Previous Job From
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {formatDate(
                                      employeePersonalDetail.previous_job_from
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Previous Job To
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {formatDate(
                                      employeePersonalDetail.previous_job_to
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Bank Name
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.bank_name}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Bank Account Number
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.bank_account_number}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    IFSC Code
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.ifsc_code}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    UAN Number
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.uan_number}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Pan Number
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.pan}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <Grid container spacing={2}>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography className={classes.label}>
                                    Aadhar Number
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  <Typography
                                    className={classes.textcapitalize}
                                  >
                                    {employeePersonalDetail.aadhar}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                          <Grid container spacing={2}>
                            <Grid item xs={6} md={6} lg={6}>
                              <Typography className={classes.label}>
                                Address
                              </Typography>
                            </Grid>

                            <Grid sx={{ ml: 1 }} item xs={6} md={6} lg={6}>
                              <Typography className={classes.textcapitalize}>
                                {user.address}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                          </Grid>
                          
                        )}
                        <Grid item xs={12} md={12} lg={12} textAlign="left">
                          <IconButton
                            onClick={toggleConfidentialInfo}
                            sx={{ color: "#3f51b5" }}
                          >
                            {showConfidentialInfo ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                            <Typography variant="button" sx={{ ml: 1 }}>
                              {showConfidentialInfo ? "Show Less" : "Show More"}
                            </Typography>
                          </IconButton>
                        </Grid>

                        <Grid item xs={12} md={12} lg={12} textAlign="right">
                          {!user.mfa ? (
                            <Button
                              variant="contained"
                              size="small"
                              className="pr-btn"
                              onClick={() =>
                                navigate("/enable-mfa", { replace: true })
                              }
                            >
                              Enable MFA
                            </Button>
                          ) : (
                            <></>
                          )}
                          {/* <Button
                            sx={{ ml: 1 }}
                            variant="contained"
                            size="small"
                            className="pr-btn"
                            onClick={() => {
                              if (user.resignation_initiated === true) {
                                dispatch(
                                  showAlert(
                                    "Resignation Request Already Submitted! Please wait for management decision !"
                                  )
                                );
                              } else {
                                setResignationDialogOpen(true);
                              }
                            }}
                          >
                            Resignation
                          </Button> */}
                          {/* <ResignationDialog
                            open={resignationDialogOpen}
                            onClose={() => setResignationDialogOpen(false)}
                            employeeId={user.id} // Pass employee ID if needed
                            refreshApi={loadEmployeePersonalDetails}
                          /> */}
                        </Grid>
                      </Grid>

                      <br />
                    </Box>
                  </Box>
                </Box>
              </Paper>

              <UpdateDialog
                open={updateDialogOpen}
                setOpen={setUpdateDialogOpen}
                employeePersonalDetail={employeePersonalDetail}
                refreshApi={loadEmployeePersonalDetails}
              />
            </Box>
          </Paper>
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <Paper>
            <FileUploadComponent documentTypeData={documentTypeData} />
          </Paper>
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <Paper>
            <FileUploadComponent documentTypeData={documentTypeData} />
          </Paper>
        </TabPanel>
      </Box>
    </>
  );
}

function UpdateDialog({ open, setOpen, employeePersonalDetail, refreshApi }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState({
    role: "",
    email: "",
    firstname: "",
    lastname: "",
    contact: "",
    address: "",
    isEmployee: "",
    dob: "",
    nationality: "",
    gender: "",
    marital_status: "",
    previous_company: "",
    other_contact: "",
    previous_job_title: "",
    previous_job_from: "",
    previous_job_to: "",
    bank_name: "",
    bank_account_number: "",
    ifsc_code: "",
    uan_number: "",
    pan: "",
    aadhar: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (open)
      setData({
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        contact: user.contact,
        address: user.address,
        // isEmployee: user.isEmployee,
        dob: employeePersonalDetail.dob,
        nationality: employeePersonalDetail.nationality,
        gender: employeePersonalDetail.gender,
        marital_status: employeePersonalDetail.marital_status,
        previous_company: employeePersonalDetail.previous_company,
        other_contact: employeePersonalDetail.other_contact,
        previous_job_title: employeePersonalDetail.previous_job_title,
        previous_job_from: employeePersonalDetail.previous_job_from,
        previous_job_to: employeePersonalDetail.previous_job_to,
        bank_name: employeePersonalDetail.bank_name,
        bank_account_number: employeePersonalDetail.bank_account_number,
        ifsc_code: employeePersonalDetail.ifsc_code,
        uan_number: employeePersonalDetail.uan_number,
        pan: employeePersonalDetail.pan,
        aadhar: employeePersonalDetail.aadhar,
      });
  }, [open, user]);

  const handleDataChange = (e) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onUpdate = async () => {
    try {
      const res = await updateProfile(data, user.token);
      dispatch(showAlert(res.data.msg));
      setOpen(false);
      dispatch(getUser(user.token));
      refreshApi();
      // window.location.reload();
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // const errors = validate(data);
          // if (Object.keys(errors).length === 0) {
          onUpdate();
          // }
        }}
      >
        <DialogTitle id="alert-dialog-title">Update Profile</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} pt={2}>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.firstname}
                label="First Name"
                className="name-textfeild"
                onChange={handleDataChange}
                name="firstname"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.lastname}
                label="Last Name"
                className="name-textfeild"
                onChange={handleDataChange}
                name="lastname"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                type="tel"
                value={data.contact}
                error={!/^[0-9]{10}$/.test(data.contact)}
                inputProps={{ maxLength: 10 }}
                label="Contact"
                onChange={handleDataChange}
                name="contact"
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                type="email"
                value={data.email}
                label="Email"
                onChange={handleDataChange}
                name="email"
                fullWidth
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={3} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Date of Birth"
                  value={data.dob}
                  onChange={(newValue) => {
                    handleDataChange({
                      target: { name: "dob", value: newValue },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
              {/* <TextField
                required
                value={data.dob}
                label="Date of Birth"
                onChange={handleDataChange}
                name="dob"
                type="date"
                fullWidth
              /> */}
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <FormControl size="small" fullWidth>
                <InputLabel id="demo-multiple-checkbox-label">
                  {"Nationality"}
                </InputLabel>
                <Select
                  size="small"
                  required
                  value={data.nationality}
                  onChange={handleDataChange}
                  fullWidth
                  name="nationality"
                >
                  <MenuItem value="indian">Indian</MenuItem>
                  <MenuItem value="non-indian">Non-Indian</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <FormControl size="small" fullWidth>
                <InputLabel id="demo-multiple-checkbox-label">
                  {"Gender"}
                </InputLabel>
                <Select
                  required
                  value={data.gender}
                  onChange={handleDataChange}
                  name="gender"
                  fullWidth
                >
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <FormControl size="small" fullWidth>
                <InputLabel id="demo-multiple-checkbox-label">
                  {"Marital Status"}
                </InputLabel>
                <Select
                  required
                  value={data.marital_status}
                  onChange={handleDataChange}
                  name="marital_status"
                  fullWidth
                >
                  <MenuItem value="married">Married</MenuItem>
                  <MenuItem value="unmarried">Unmarried</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.previous_company}
                label="Previous Company"
                onChange={handleDataChange}
                name="previous_company"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.other_contact}
                label="Other Contact"
                onChange={handleDataChange}
                name="other_contact"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                value={data.previous_job_title}
                label="Previous Job Title"
                onChange={handleDataChange}
                name="previous_job_title"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Previous Job From"
                  value={data.previous_job_from}
                  onChange={(newValue) => {
                    handleDataChange({
                      target: {
                        name: "previous_job_from",
                        value: newValue === null ? undefined : newValue,
                      },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
              {/* <TextField
                required
                value={data.previous_job_from}
                label="Previous Job From"
                onChange={handleDataChange}
                name="previous_job_from"
                type="date"
                fullWidth
              /> */}
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                  inputFormat="MM/dd/yyyy"
                  label="Previous Job To"
                  value={data.previous_job_to}
                  onChange={(newValue) => {
                    handleDataChange({
                      target: {
                        name: "previous_job_to",
                        value: newValue === null ? undefined : newValue,
                      },
                    });
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>

              {/* <TextField
                required
                value={data.previous_job_to}
                label="Previous Job To"
                onChange={handleDataChange}
                name="previous_job_to"
                type="date"
                fullWidth
              /> */}
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.bank_name}
                label="Bank Name"
                onChange={handleDataChange}
                name="bank_name"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.bank_account_number}
                label="Bank Account Number"
                onChange={handleDataChange}
                name="bank_account_number"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.ifsc_code}
                label="IFSC Code"
                onChange={handleDataChange}
                name="ifsc_code"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.uan_number}
                label="UAN Number"
                onChange={handleDataChange}
                name="uan_number"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.pan}
                label="PAN"
                onChange={handleDataChange}
                name="pan"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={3} md={3}>
              <TextField
                required
                value={data.aadhar}
                label="Aadhar"
                onChange={handleDataChange}
                name="aadhar"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                multiline={true}
                rows={2}
                required
                value={data.address}
                label="Address"
                onChange={handleDataChange}
                name="address"
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
              setData({
                role: "",
                email: "",
                firstname: "",
                lastname: "",
                contact: "",
                address: "",
                // isEmployee: "",
                dob: "",
                nationality: "",
                gender: "",
                marital_status: "",
                previous_company: "",
                other_contact: "",
                previous_job_title: "",
                previous_job_from: "",
                previous_job_to: "",
                bank_name: "",
                bank_account_number: "",
                ifsc_code: "",
                uan_number: "",
                pan: "",
                aadhar: "",
              });
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button type="submit" autoFocus className="blue-button">
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
function formatDate(data) {
  const date = new Date(data);
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const day = date.getDate().toString().padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  return data === "" || data === null ? "" : formattedDate;
}
